import React from 'react';

export default () => {
  window.rnwWidget = window.rnwWidget || {};
  window.rnwWidget.configureWidget = window.rnwWidget.configureWidget || [];
  window.rnwWidget.configureWidget.push(function(options) {
    options.epikOptions.test_mode = process.env.NODE_ENV !== 'production';
  });

  const script = document.createElement('script');
  script.async = true;
  // TODO: replace language in referenced JS
  script.src = 'https://lema.raisenow.com/widgets/lema/mycli-2040/js/dds-init-widget-de.js';
  document.body.appendChild(script);

  return (
    <div className="dds-widget-container" data-widget="lema"></div>
  );
}
